export default __webpack_public_path__ + "static/media/HDTX_LKTT 2023.d6bf971d.pdf";